export default {
  copyright: 'Copyright © KEY LEARNING SpA {year}. All rights reserved.',
}
